export default __webpack_public_path__ + "static/media/banner1.b831d4ca.png";